import Error from '../model/Error';
import OfferingAppointment from '../dto/offering/OfferingAppointment';
import QueryParamEncoder from '../service/QueryParamEncoder';
import axios from 'axios';
import moment from 'moment';

export default class AppointmentRepository {

    static findAll(offeringId, from, to) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/offerings/${offeringId}/appointments/${from}/${to}`)
                .then(response => resolve(response.data.data.map(data => OfferingAppointment.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByFilter(clubId, from, to, filters) {

        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/appointments/${from}/${to}?${QueryParamEncoder.encodeObjectToArray(filters, 'filters')}`)
                .then(response => resolve(response.data.data.map(data => OfferingAppointment.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateCancelById(appointment, notifyParticipants, notifyClubEmployees) {
        const formattedStart = moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format();

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/appointments/appointment-series/${appointment.appointmentSeries.id}/start/${formattedStart}/cancel`, {
                    isCanceled: true,
                    notifyParticipants: notifyParticipants,
                    notifyClubEmployees: notifyClubEmployees
                })
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static reactivateById(appointment, notifyParticipants, notifyClubEmployees) {
        const formattedStart = moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format();

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/appointments/appointment-series/${appointment.appointmentSeries.id}/start/${formattedStart}/reactivate`, {
                    isCanceled: false,
                    notifyParticipants: notifyParticipants,
                    notifyClubEmployees: notifyClubEmployees
                })
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(appointment, notifyParticipants, notifyClubEmployees) {
        const formattedStart = moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format();
        const instructors = [];
        if (appointment.appointmentOverride) {
            appointment.appointmentOverride.instructors.forEach(instructor => instructors.push(instructor.value));
        }
        const fields = [];
        if (appointment.appointmentOverride) {
            appointment.appointmentOverride.fields.forEach(field => fields.push(field.value));
        }
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/appointments/appointment-series/${appointment.appointmentSeries.id}/start/${formattedStart}`, {
                    title: appointment.appointmentOverride.title,
                    note: appointment.appointmentOverride.note,
                    instructorIds: instructors,
                    fieldIds: fields,
                    isCanceled: appointment.appointmentOverride.isCanceled,
                    notifyParticipants: notifyParticipants,
                    notifyClubEmployees: notifyClubEmployees
                })
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
